// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Rectangle } from '@shared/commons/Geometry';
import { buttonsPopupHandler } from '@shared/utils/AppHandlers';
import TerceraButtonsPopupTemplate from '@front/templates/TerceraButtonsPopupTemplate.html';
import { ContainerControl } from './ContainerControl';
import { ControlsUtils } from '../UtilsClasses/ControlsUtils';
export class TerceraButtonsPopup extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return 'TerceraButtonsPopup';
    }
    oninit() {
        super.oninit();
        this.onButtonClicked = this.onButtonClicked.bind(this);
    }
    getClientPanel() {
        return this.find('.js-buttons-popup');
    }
    onButtonClicked() {
        this.Hide();
    }
    onItemClicked(item) {
        if (item === null || item === void 0 ? void 0 : item.event) {
            item.event(item.type);
        }
    }
    Hide() {
        this.removeAllControls();
        void this.set('visible', false);
        this.lostFocus();
    }
    show(items, x, y, maxColumnsCount) {
        if (typeof this.el !== 'object') {
            this.el = document.getElementById(this.el);
            void this.render(this.el);
        }
        if ((items === null || items === void 0 ? void 0 : items.length) === 0) {
            return;
        }
        if (typeof this.el !== 'object') {
            this.el = document.getElementById(this.el);
            void this.render(this.el);
        }
        const rowsCount = Math.ceil(items.length / maxColumnsCount);
        const columnsCount = items.length < maxColumnsCount ? items.length : maxColumnsCount;
        const margin = 3;
        const sizeBtn = 30;
        const w = margin + columnsCount * (sizeBtn + margin);
        const h = margin + rowsCount * (sizeBtn + margin);
        const newLocation = ControlsUtils.CorrectPopupLocation(new Rectangle(x, y, w, h));
        // Positioning.
        void this.set({
            left: newLocation.newX,
            top: newLocation.newY,
            width: w,
            visible: true,
            popupItems: items
        });
    }
    static ButtonsPopupHandlerInitialize() {
        const _buttonsPopup = new TerceraButtonsPopup();
        buttonsPopupHandler.set = (key) => __awaiter(this, void 0, void 0, function* () {
            yield _buttonsPopup.set(key);
        });
        buttonsPopupHandler.get = (key) => {
            return _buttonsPopup.get(key);
        };
        buttonsPopupHandler.Hide = _buttonsPopup.Hide.bind(_buttonsPopup);
        buttonsPopupHandler.show = _buttonsPopup.show.bind(_buttonsPopup);
        buttonsPopupHandler.onButtonClicked = _buttonsPopup.onButtonClicked.bind(_buttonsPopup);
        buttonsPopupHandler.addControl = _buttonsPopup.addControl.bind(_buttonsPopup);
    }
}
ContainerControl.extendWith(TerceraButtonsPopup, {
    el: '#buttonsPopupContainer',
    template: TerceraButtonsPopupTemplate,
    data: function () {
        return {
            visible: false,
            popupItems: null
        };
    }
});
